module.exports = __webpack_public_path__ + "static/media/cdb22.066fa8cd.png";